import {createReducer} from "./index";
import * as R from 'ramda';
import {ADD_LOGOS} from "../actions/companies";

const filesInitial = {
  data: {},
  indexes: {
  }
};

function addFiles(state, files) {
  let newState = state;
  files.forEach(file => {
    if (!file) return;
    newState = R.over(R.lensPath(['data', file.id]), () => file)(newState);
  });
  return newState;
}

const logosReducer = createReducer(filesInitial,
  {
    // 'ACTION_NAME': function (state, action) -> new_state
    [ADD_LOGOS]: (state, action) => addFiles(state, action.payload),
  });

export default logosReducer;



// WEBPACK FOOTER //
// ./src/reducers/logos.js